import accountsTabListTemplate from './accountsTabList.html';
import {DETAIL_ACCOUNTROUTE} from '../../../views/accounts/AccountController';

/**
 * Tab top list view
 * Shows a list of the top currencies, banks, countries and calculates balances in given consolidation currency
 */
export function accountsTabListDirective($rootScope, $state) {
    return {
        scope: {
            'type': '@',
            'controller': '=',
            'mostUsed': '=',
            'totalSum': '=',
            'fractionDigits': '=',
            'numberOfAccounts': '='
        },
        templateUrl: accountsTabListTemplate,
        link: scope => {
            scope.filterFor = (item, type) => {
                if (item.code !== 'OTHER') {
                    if(type === 'overview') {
                        $state.go(DETAIL_ACCOUNTROUTE, { id: item.code });
                    } else {
                        $rootScope.$broadcast('expandGroupData', item);
                    }
                }
            }
        }
    }
}
